<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title v-for="header in $store.state.orders.hbGroup" :key="header.id">{{ header.id | formatHbState }}
        ({{ header.value }})
      </v-toolbar-title>


    </v-toolbar>
    <v-toolbar flat color="white">
      <v-toolbar-title>Siparişler ({{ filteredOrders.length }})</v-toolbar-title>
      <v-toolbar-title>Has Ortalama: {{ hasAverage | formatMoney }}</v-toolbar-title>
    </v-toolbar>

    <!-- Responsive Filter Container -->
    <v-container fluid class="pa-2">
      <v-layout wrap>
        <!-- Date Fields Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu v-model="menu1" :close-on-content-click="false" lazy transition="scale-transition" offset-y
                full-width min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="startDate" label="Baş. Tarihi" prepend-icon="event" readonly
                    v-on="on"></v-text-field>
                </template>
                <v-date-picker @change="initialize" v-model="startDate" locale="tr-TR"
                  @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu v-model="menu2" :close-on-content-click="false" lazy transition="scale-transition" offset-y
                full-width min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="endDate" label="Bit. Tarihi" prepend-icon="event" readonly
                    v-on="on"></v-text-field>
                </template>
                <v-date-picker @change="initialize" v-model="endDate" locale="tr-TR"
                  @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-text-field v-model="search" @keyup.enter.native="initialize" append-icon="search" label="Ara"
                clearable></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-btn color="primary" block @click="initialize" class="mt-3">
                <v-icon left>search</v-icon>
                Ara
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- Filter Fields Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <v-combobox v-model="select" :items="this.$store.getters['orders/getStateItems']" item-value="id"
                @change="initialize" item-text="value" label="Sipariş Durumları" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <v-combobox v-model="selectedInsuranceFilter" :items="this.insuranceFilters" item-value="id"
                item-text="value" label="Sigorta" @change="initialize" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <v-combobox v-model="selectedHbStateFilters" :items="this.$store.getters['orders/getHbStateItems']"
                item-value="id" item-text="value" label="Mp Durum" @change="initialize" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <v-combobox v-model="selectedCityFilters" :items="this.$store.state.orders.city" item-value="id"
                item-text="value" label="Şehir" @change="initialize" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1" v-if="showPaymentMethodFilter">
              <v-combobox v-model="selectedPaymentMethod" :items="paymentMethodFilters" item-value="id"
                item-text="value" label="Ödeme Yöntemi" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <div class="mt-3">
                <v-switch @change="initialize" v-model="isNotMatchComission" :label="`Eşleşmeyen Komisyon`"
                  color="primary"></v-switch>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table :headers="tableHeaders" :loading="this.$store.state.progress" :rows-per-page-items="pageItems"
      :items="filteredOrders" :pagination.sync="pagination" item-key="id" select-all v-model="selected"
      class="elevation-1">
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details
              @click.stop="toggleAll"></v-checkbox>
          </th>
          <th v-for="header in props.headers" :key="header.text" class="px-0 text-xs-left" :class="[
            'column sortable',
            pagination.descending ? 'desc' : 'asc',
            header.value === pagination.sortBy ? 'active' : '',
          ]" @click="changeSort(header.value)">
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected"
          v-for="(orderItem, key) in props.item.items" :key="key">
          <td>
            <v-checkbox v-if="key === 0" :input-value="props.selected" primary hide-details></v-checkbox>
          </td>
          <td class="px-0" v-if="showCustomerNotes" style="padding-left: 0; margin-left: -8px;">
            <v-btn v-if="props.item.customerNotes" icon small color="amber darken-2"
              @click.stop="openCustomerNotesDialog(props.item.customerNotes)" style="margin-left: -4px;">
              <v-icon small>speaker_notes</v-icon>
            </v-btn>
            <v-btn v-else icon small disabled style="opacity: 0.3; margin-left: -4px;">
              <v-icon small>speaker_notes</v-icon>
            </v-btn>
          </td>
          <!-- <td class="px-0">{{ props.item.id }}</td> -->
          <td class="px-1">{{ props.item.indicator }}</td>
          <td class="px-2">{{ props.item.orderDate | formatDate }}</td>
          <td class="px-2">{{ props.item.barcode }}</td>
          <td class="px-2">{{ props.item.identityNo }}</td>
          <td class="px-2">
            <span v-if="props.item.isDuplicate" style="background-color: red; color:white;font-size: 18px;">Sipariş
              Tekrarı {{
                orderItem.orderNumber
              }}</span>
            <span v-if="!props.item.isDuplicate"> {{ orderItem.orderNumber }}</span>
          </td>

          <td class="px-2">{{ props.item.shippingCity }}</td>
          <td class="px-2">{{ props.item.recipientName }}</td>
          <td class="px-2" v-if="tenantId == 2" v-bind:class="[
            orderItem.customizedText01,
            orderItem.customizedText01.length != 26 ? 'redd' : '',
          ]">
            {{ orderItem.bankName }}-{{ orderItem.customizedText01 }}
          </td>
          <td class="px-2">{{ orderItem.hbSku }}</td>
          <td class="px-2">{{ orderItem.productName }}</td>
          <td class="px-2">
            <span v-if="props.item.state == 2">
              {{
                props.item.isSendInsurance ? "Sigortalandı" : "Sigortalanmadı"
              }} {{ props.item.insuranceTrackerMessage }}</span>
          </td>

          <td class="px-2">{{ orderItem.quantity }} -
            {{(orderItem.orderPaymentItems.find(k => k.transactionType === 4) || { quantity: 0 }).quantity}}
          </td>
          <td class="px-2">
            {{ orderItem.discountRate }} <span v-if="orderItem.discountRate != orderItem.discountRateNew"
              style="color: red;">Yeni: {{ orderItem.discountRateNew }}</span>
          </td>
          <td class="px-2">
            {{ orderItem.hasAverage }} <span
              v-if="orderItem.hasAverageNew > 0 && orderItem.hasAverage != orderItem.hasAverageNew"
              style="color: red;">Yeni:
              {{
                orderItem.hasAverageNew
              }}</span>
          </td>
          <td class="px-2">
            {{
              (orderItem.totalPrice.amount / orderItem.quantity) | formatMoney
            }}
          </td>
          <td class="px-2">{{ orderItem.totalPrice.amount | formatMoney }}</td>
          <td class="px-2">{{ props.item.state | formatState }}</td>
          <td class="px-2">{{ orderItem.status | formatHbState }}</td>
          <td class="px-2">{{ props.item.gibState | formatUyumStates }}</td>
          <td class="px-2" v-if="showReferenceColumn && !props.item.isReferenceNumberSend">
            <v-text-field v-model="referenceNumbers[props.item.id]" placeholder="Referans No" dense hide-details
              style="width: 120px; margin-bottom: 5px;"></v-text-field>
            <v-btn small color="orange" dark @click="sendReferenceNumber(props.item, orderItem)"
              :loading="referenceLoadingStates[props.item.id]" :disabled="!referenceNumbers[props.item.id]">
              Gönder
            </v-btn>
          </td>
          <td class="px-2" v-if="showReferenceColumn && props.item.isReferenceNumberSend">
            <span style="color: green;">✓ Gönderildi</span>
          </td>
          <td class="px-2" v-if="showPaymentActionFilter">
            <v-btn v-if="shouldShowPaymentAction(orderItem, props.item)" small color="primary" dark
              @click.stop="openPaymentActionModal(props.item)">İşlem</v-btn>
          </td>
          <!-- <td class="px-0">
                      <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                      <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>-->
        </tr>
      </template>

      <!-- <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>-->
    </v-data-table>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md8>
        <v-btn color="primary" dark @click="barcodePrint" class="mb-2">Yazdır
        </v-btn>
        <v-btn color="primary" outlined dark @click="barcodePrintOld" class="mb-2">Yazdır (eski)
        </v-btn>
        <v-btn color="primary" dark @click="invoicePrint" class="mb-2">Fatura Yazdır
        </v-btn>
        <v-btn color="primary" dark @click="poolOrderAction" class="mb-2">Excel Havuza Aktar
        </v-btn>
        <v-btn color="green" dark @click="reSendInvoice" class="mb-2">Faturaları Tekrar Aktar
        </v-btn>
        <!--        <v-btn-->
        <!--            color="yellow darken-1"-->
        <!--            text-->
        <!--            @click="popupInsurance"-->
        <!--        >Sigortala-->
        <!--        </v-btn>-->
        <v-divider class="mx-2" inset vertical></v-divider>
        <input type="file" @change="uploadFile" ref="file">
        <v-btn color="yellow darken-1" dark @click="pictureUploadEvent" class="mb-2">Sigortayı Yükle</v-btn>
        <v-divider class="mx-2" inset vertical></v-divider>


      </v-flex>
      <v-flex xs12 md2>
        <v-combobox v-model="selectedAction" :items="this.$store.getters['orders/getStateItems']" item-value="id"
          item-text="value" hide-details></v-combobox>
      </v-flex>
      <v-flex xs12 md2>
        <v-btn color="primary" dark @click="saveAction" class="mb-2">Güncelle
        </v-btn>
      </v-flex>
      <v-dialog v-model="insuranceDialog" persistent max-width="1250">

        <v-card>
          <v-card-title class="headline">Sigorta</v-card-title>
          <!--          <v-card-text>Sigorta Şirketi Seçiniz</v-card-text>-->
          <v-container>
            <v-data-table :headers="headersInsurance" :items="insuranceItems" :pagination.sync="pagination"
              :rows-per-page-items="pageItems" class="elevation-1">
              <template v-slot:headers="props">
                <tr>
                  <th v-for="header in props.headers" :key="header.text" class="px-0 text-xs-center"
                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)">
                    {{ header.text }}
                    <v-icon small>arrow_upward</v-icon>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td class="px-0 text-xs-center">{{ props.item.barcode }}</td>
                <td class="px-0 text-xs-center">{{ props.item.insuranceBagNumber }}</td>
                <td class="px-0 text-xs-center" v-if="props.item.isSendInsurance == 1">Sigortalandı</td>
                <td class="px-0 text-xs-center" v-else>Gönderilemedi</td>
                <td class="px-0 text-xs-center">{{ props.item.insuranceTrackerCode }}</td>
                <td class="px-0 text-xs-center">{{ props.item.insuranceTrackerMessage }}</td>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
              </template>
            </v-data-table>

            <v-layout wrap justify-space-between>

              <!--              <v-combobox-->
              <!--                  v-model="selectedInsurance"-->
              <!--                  :items="this.$store.state.insurances.insurances"-->
              <!--                  item-value="id"-->
              <!--                  item-text="name"-->
              <!--                  hide-details-->
              <!--              ></v-combobox>-->
              <!--              <v-text-field v-model="posetSeri" label="Poşet Seri" required></v-text-field>-->
              <!--              <v-text-field v-model="posetNo" :counter="max" label="Poşet No Başlangıç"-->
              <!--                            required></v-text-field>-->


            </v-layout>
          </v-container>

          <v-card-actions>
            <v-spacer></v-spacer>

            <!--            <download-excel-->
            <!--                class="v-btn warning"-->
            <!--                :data="selected"-->
            <!--                :fetch="saveInsurance"-->

            <!--                :fields="json_fields"-->
            <!--                worksheet="Sheet1"-->
            <!--                name="sigorta.xls"-->
            <!--            >Sigortala-->
            <!--            </download-excel-->
            <!--            >-->
            <v-btn color="green darken-1" text @click="insuranceDialog = false">Tamam
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="paymentActionDialog" max-width="900px" persistent>
        <v-card class="elevation-2">

          <!-- Modern Header -->
          <v-card-title class="headline white--text primary darken-1 elevation-2">
            <v-icon left color="white" size="26">verified</v-icon>
            <span class="font-weight-bold">İşlem Onayı</span>

            <v-spacer></v-spacer>

            <v-btn icon dark @click="closePaymentActionModal">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-4" v-if="paymentActionOrder">
            <v-container fluid class="pa-0">
              <v-card class="mb-4 elevation-1" outlined>
                <v-card-title class="subtitle-1 primary--text py-2">
                  <v-icon left color="primary">receipt_long</v-icon>
                  İşlem Bilgileri
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 sm6 class="py-2">
                      <div class="caption grey--text">Sipariş Tarihi</div>
                      <div class="body-2 font-weight-medium">
                        {{ paymentActionOrder.orderDate | formatDate }}
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 class="py-2">
                      <div class="caption grey--text">Tutar</div>
                      <div class="body-2 font-weight-bold success--text">
                        {{ paymentActionOrderTotal | formatMoney }}
                      </div>
                    </v-flex>
                    <v-flex xs12 class="py-2">
                      <div class="caption grey--text">Alıcı</div>
                      <div class="body-2 font-weight-medium">
                        {{ paymentActionOrder.recipientName }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <v-card class="mb-4 elevation-1" outlined>
                <v-card-title class="subtitle-1 primary--text py-2">
                  <v-icon left color="primary">compare_arrows</v-icon>
                  Fiyat Karşılaştırması
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-progress-linear
                    v-if="priceComparisonLoading"
                    indeterminate
                    color="primary"
                    class="mb-3"
                  ></v-progress-linear>

                  <div v-else-if="priceComparisonData.length === 0" class="text-center grey--text">
                    Karşılaştırılacak ürün bulunamadı.
                  </div>

                  <div v-else>
                    <v-layout wrap class="mb-3">
                      <v-flex xs12 sm4 class="py-2">
                        <div class="caption grey--text">Mevcut Toplam Fiyat</div>
                        <div class="body-1 font-weight-bold">
                          {{ totalCurrentPrice | formatMoney }}
                        </div>
                      </v-flex>
                      <v-flex xs12 sm4 class="py-2">
                        <div class="caption grey--text">Güncel Toplam Fiyat</div>
                        <div class="body-1 font-weight-bold">
                          {{ totalCurrentPriceFromDb | formatMoney }}
                        </div>
                      </v-flex>
                      <v-flex xs12 sm4 class="py-2">
                        <div class="caption grey--text">Toplam Fark</div>
                        <div
                          class="body-1 font-weight-bold"
                          :class="totalPriceDifference >= 0 ? 'success--text' : 'error--text'"
                        >
                          <span v-if="totalPriceDifference !== 0">
                            {{ totalPriceDifference >= 0 ? '+' : '' }}{{ totalPriceDifference | formatMoney }}
                          </span>
                          <span v-else>Fark yok</span>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-data-table
                      :headers="priceComparisonHeaders"
                      :items="priceComparisonData"
                      :rows-per-page-items="[5, 10, 25]"
                      class="elevation-1"
                      dense
                    >
                      <template v-slot:items="props">
                        <td class="px-2">{{ props.item.productName }}</td>
                        <td class="px-2">{{ props.item.quantity }}</td>
                        <td class="px-2">{{ props.item.currentUnitPrice | formatMoney }}</td>
                        <td class="px-2">{{ props.item.currentTotalPrice | formatMoney }}</td>
                        <td class="px-2">{{ props.item.dbUnitPrice | formatMoney }}</td>
                        <td class="px-2">{{ props.item.dbTotalPrice | formatMoney }}</td>
                        <td
                          class="px-2"
                          :class="props.item.difference >= 0 ? 'success--text' : 'error--text'"
                        >
                          <strong v-if="props.item.difference !== 0">
                            {{ props.item.difference >= 0 ? '+' : '' }}{{ props.item.difference | formatMoney }}
                          </strong>
                          <strong v-else>Fark yok</strong>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card-text>

          <!-- Action Buttons -->
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>

            <v-btn text color="grey" @click="closePaymentActionModal">
              <v-icon left>close</v-icon>
              Vazgeç
            </v-btn>

            <v-btn color="red" dark depressed @click="handlePaymentReject">
              <v-icon left>cancel</v-icon>
              Reddet
            </v-btn>

            <v-btn color="green" dark depressed @click="handlePaymentApprove">
              <v-icon left>check_circle</v-icon>
              Onayla
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
      <v-dialog v-model="actionConfirmDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">Emin misiniz?</v-card-title>
          <v-card-text>
            <div v-if="confirmActionType === 'approve'">
              Bu siparişi onaylamak istediğinize emin misiniz?
            </div>
            <div v-else>
              Bu siparişi reddetmek istediğinize emin misiniz?
            </div>
            <v-textarea
                v-if="confirmActionType === 'reject'"
                v-model="confirmCancelNote"
                label="Not (opsiyonel)"
                rows="2"
                auto-grow
                class="mt-4"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeConfirmDialog">Vazgeç</v-btn>
            <v-btn
                color="primary"
                :loading="confirmActionLoading"
                @click="confirmPaymentAction"
            >Evet</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="customerNotesDialog" max-width="500">
        <v-card>
          <v-card-title class="headline amber darken-2 white--text">
            <v-icon left color="white">speaker_notes</v-icon>
            Müşteri Notu
          </v-card-title>
          <v-card-text class="pa-4">
            <div class="body-1" style="white-space: pre-wrap; word-break: break-word; overflow-wrap: break-word;">{{ customerNotesContent }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="customerNotesDialog = false">Kapat</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Api from "@/api/baseApi";
import moment from "moment/moment";
import { authenticationService } from "@/_services";
import productsApi from "@/api/products";
import mpProductsApi from "@/api/mpProducts";

export default {
  data: () => ({
    startDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu1: false,
    modal: false,
    tenantId: 0,
    mpId: 0,
    insuranceDialog: false,
    menu2: false,
    hasAverage: null,
    isNotMatchComission: false,
    pagination: {
      sortBy: "name",
    },
    files: null,
    select: { id: -1, value: "Tümü" },
    selectedAction: { id: -1, value: "Durum Seç" },
    selectedInsurance: { id: -1, name: "Sigorta Seç" },
    selectedInsuranceFilter: { id: -1, value: "Tümü" },
    selectedHbStateFilters: { id: "", value: "Tümü" },
    selectedCityFilters: { id: "-1", value: "Tümü" },
    selectedPaymentMethod: null,
    search: null,
    selected: [],
    insuranceItems: [],
    orders: [],
    pageItems: [
      50,
      100,
      500,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    max: 0,
    posetSeri: "AAB",
    posetNo: 2374301,
    referenceLoadingStates: {},
    referenceNumbers: {},
    paymentActionDialog: false,
    paymentActionOrder: null,
    actionConfirmDialog: false,
    confirmActionType: null,
    confirmActionLoading: false,
    confirmCancelNote: "",
    priceComparisonLoading: false,
    priceComparisonData: [],
    priceComparisonHeaders: [
      { text: "Ürün Adı", value: "productName" },
      { text: "Miktar", value: "quantity" },
      { text: "Mevcut Birim Fiyat", value: "currentUnitPrice" },
      { text: "Mevcut Toplam", value: "currentTotalPrice" },
      { text: "Güncel Birim Fiyat", value: "dbUnitPrice" },
      { text: "Güncel Toplam", value: "dbTotalPrice" },
      { text: "Fark", value: "difference" },
    ],
    customerNotesDialog: false,
    customerNotesContent: "",

    insuranceFilters: [{
      id: "-1",
      value: "Durum Seç"
    },
    {
      id: 1,
      value: "Sigortalandı"
    },
    {
      id: 0,
      value: "Sigortalanmadı"
    }
    ],
    headersInsurance: [
      { text: "Barkod", value: "barcode" },
      { text: "Poşet", value: "insuranceBagNumber" },
      { text: "Sigortalandı mı?", value: "isSendInsurance" },
      { text: "Takip No", value: "insuranceTrackerCode" },
      { text: "Mesaj", value: "insuranceTrackerMessage" },
    ],
    headers: [
      // {
      //   text: "Id",
      //   align: "left",
      //   value: "id"
      // },
      { text: "Not", value: "customerNotes", sortable: false },
      { text: "Etiket", value: "indicator" },
      { text: "Sipariş Tarih", value: "orderDate" },
      { text: "Barkod", value: "barcode" },
      { text: "Tc", value: "tc" },
      { text: "Sipariş No", value: "shipmentNo" },

      { text: "Şehir", value: "shippingCity" },
      { text: "Adı", value: "recipientName" },

      { text: "İban", value: "customizedText01" },
      { text: "Ürün Kodu", value: "productCode" },
      { text: "Ürün Adı", value: "productName" },
      { text: "Sigorta", value: "insuranceId" },
      { text: "Miktar", value: "amount" },
      { text: "İndirim", value: "discountRate" },
      { text: "Has Ort", value: "hasAverage" },

      { text: "Birim Fiyatı", value: "" },
      { text: "Satış Fiyatı", value: "salePrice" },
      { text: "Durum", value: "state" },
      { text: "Mp Durum", value: "status" },
      { text: "Gib Durum", value: "gibState" },
      { text: "Referans No", value: "referenceNumber", sortable: false },
      { text: "İşlem", value: "paymentAction", sortable: false },
      // { text: "İşlem", value: "name", sortable: false }
    ],
    json_fields: {
      Tarih: {
        field: "orderDate",
        callback: () => {
          return `${moment(String(new Date())).format("DD.MM.YYYY")}`;
        },
      },
      "Ödeme Türü": { callback: () => "Sigorta Gönderici Kargo Alıcı" },
      "Entegrasyon Türü": { callback: () => "Entegrasyonsuz" },
      "Alıcı İsmi": "companyName",
      "Alıcı Telefon": {
        field: "phoneNumber",
        callback: (value) => {
          return `${value.toString()} `;
        }
      },
      "Alıcı Kimlik No": "identityNo",
      "Alıcı Vergi Dairesi": { callback: () => "" },
      "Alıcı Vergi Numarası": { callback: () => "" },
      "Ürün Türü": { callback: () => "Altın" },
      "Şube": { callback: () => "Çobançeşme Şubesi" },
      "Poşet Numarası": "poset",
      "Teslim Alacak İsim": {
        field: "recipientName",
        callback: (value) => {
          return `${value.toString().replace(value.split(' ')[1], '')}`;
        },
      },
      "Teslim Alacak Soyisim": {
        field: "recipientName",
        callback: (value) => {
          return `${value.toString().split(' ')[1]}`;
        },
      },
      "Teslim Alacak Telefon": "phoneNumber",
      "Teslimat Adres Başlığı": { callback: () => "" },

      "Adres Metni": "shippingAddressDetail",
      "İlçe": "shippingTown",
      "İl": "shippingCity",
      "Ürün Tutarı": {
        field: "totalAmount",
        callback: (value) => {
          return `${value.toString().replace(".", ",")}`;
        }
      },
      "Gönderi Notları": { callback: () => "" },
      "Gönderi Notları 2": { callback: () => "" },
      "Satış Kanalı": { callback: () => "" },
      "Pazaryeri": { callback: () => "Hepsiburada" },
      "Kargo": { callback: () => "yk" },

    },
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    paymentMethodFilters: [
      { id: -1, value: "Ödeme Yöntemi" },
      { id: 0, value: "Havale / EFT" },
      { id: 1, value: "Kredi Kartı" },
    ],
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
    selectedPaymentMethod() {
      this.selected = [];
    },
  },

  computed: {
    filteredOrders() {
      if (
        !this.showPaymentMethodFilter ||
        !this.selectedPaymentMethod ||
        this.selectedPaymentMethod.id === -1 ||
        this.selectedPaymentMethod.id === null
      ) {
        return this.orders;
      }
      return this.orders.filter((order) => {
        if (order.paymentMethod === undefined || order.paymentMethod === null) {
          return false;
        }
        return Number(order.paymentMethod) === Number(this.selectedPaymentMethod.id);
      });
    },
    showPaymentMethodFilter() {
      return Number(this.mpId) === 5;
    },
    showPaymentActionFilter() {
      return Number(this.mpId) === 5;
    },
    showCustomerNotes() {
      return Number(this.mpId) === 5;
    },
    showReferenceColumn() {
      return Number(this.tenantId) === 2 && Number(this.mpId) === 4;
    },
    tableHeaders() {
      let currentHeaders = this.headers;
      if (!this.showReferenceColumn) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "referenceNumber"
        );
      }
      if (!this.showPaymentActionFilter) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "paymentAction"
        );
      }
      if (!this.showCustomerNotes) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "customerNotes"
        );
      }
      return currentHeaders;
    },
    paymentActionOrderTotal() {
      if (!this.paymentActionOrder) {
        return 0;
      }
      return this.calculateOrderTotal(this.paymentActionOrder);
    },
    totalCurrentPrice() {
      return this.priceComparisonData.reduce((sum, item) => sum + (item.currentTotalPrice || 0), 0);
    },
    totalCurrentPriceFromDb() {
      return this.priceComparisonData.reduce((sum, item) => sum + (item.dbTotalPrice || 0), 0);
    },
    totalPriceDifference() {
      return this.totalCurrentPriceFromDb - this.totalCurrentPrice;
    },
  },

  created() {
    //this.initialize();
  },

  methods: {
    uploadFile() {
      debugger;
      this.files = this.$refs.file.files[0];
    },

    async pictureUploadEvent() {
      if (this.files) {
        const formData = new FormData();
        formData.append('file', this.files);
        this.insuranceItems = await this.$store.dispatch("orders/uploadInsurance", formData);
        this.insuranceDialog = true;
      }
    },

    async initialize() {
      this.$store.dispatch("orders/hbStatusGroup", {
        startDate: this.startDate,
        endDate: this.endDate,
      }).then(() => {
      });

      await this.$store.dispatch("orders/searchOrder", {
        search: this.search,
        startDate: this.startDate,
        endDate: this.endDate,
        state: this.select.id,
        insuranceId: this.selectedInsuranceFilter.id,
        hbState: this.selectedHbStateFilters.id,
        city: this.selectedCityFilters.id,
        isComission: this.isNotMatchComission
      });
      this.orders = this.$store.state.orders.all;
      this.hasAverage = (await Api.get(
        `api/reports/getHasAverage?startDate=${this.getDate(
          0
        )}&endDate=${this.getDate(+1)}`
      )).data;
    },
    getDate(day) {
      return new Date()
        .addDays(day)
        .toISOString()
        .substr(0, 10);
    },
    editItem(item) {
      this.$router.push({ name: "order-detail", params: { id: item.id } });
    },

    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        this.$store.dispatch("orders/deleteOrder", item);
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.filteredOrders.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    shouldShowPaymentAction(orderItem, order) { // eslint-disable-line no-unused-vars
      if (!order) {
        return false;
      }
      return (
        Number(this.mpId) === 5 &&
          Number(order.state) === 5 &&
        order.paymentMethod !== undefined &&
        Number(order.paymentMethod) === 0
      );
    },
    async openPaymentActionModal(order) {
      this.paymentActionOrder = order;
      this.paymentActionDialog = true;
      await this.loadPriceComparisonData(order);
    },
    openCustomerNotesDialog(notes) {
      this.customerNotesContent = notes;
      this.customerNotesDialog = true;
    },
    closePaymentActionModal() {
      this.paymentActionDialog = false;
      this.paymentActionOrder = null;
      this.priceComparisonData = [];
      this.priceComparisonLoading = false;
    },
    handlePaymentReject() {
      this.confirmActionType = "reject";
      this.confirmCancelNote = "";
      this.actionConfirmDialog = true;
    },
    handlePaymentApprove() {
      this.confirmActionType = "approve";
      this.actionConfirmDialog = true;
    },
    closeConfirmDialog() {
      this.actionConfirmDialog = false;
      this.confirmActionType = null;
      this.confirmCancelNote = "";
      this.confirmActionLoading = false;
    },
    async confirmPaymentAction() {
      if (!this.confirmActionType) {
        return;
      }
      this.confirmActionLoading = true;
      const stateId = this.confirmActionType === "reject" ? 3 : 0;
      const extras =
          this.confirmActionType === "reject" && this.confirmCancelNote
              ? { canceledNote: this.confirmCancelNote }
              : {};
      try {
        await this.updatePaymentActionState(stateId, extras);
        this.closeConfirmDialog();
      } finally {
        this.confirmActionLoading = false;
      }
    },
    async updatePaymentActionState(stateId, extraPayload = {}) {
      if (!this.paymentActionOrder) {
        return;
      }
      try {
        await this.$store.dispatch("orders/bulkUpdateStates", {
          selectedItems: [this.paymentActionOrder],
          stateId,
          ...extraPayload,
        });
        this.$store.state.dialog = true;
        this.$store.state.message =
          stateId === 3 ? "Sipariş reddedildi." : "Sipariş onaylandı.";
        await this.initialize();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Payment action state update failed", error);
        this.$store.state.dialog = true;
        this.$store.state.message =
          "İşlem gerçekleştirilirken bir hata oluştu.";
      } finally {
        this.closePaymentActionModal();
      }
    },
    calculateOrderTotal(order) {
      if (!order || !order.items) {
        return 0;
      }
      return order.items.reduce((sum, item) => {
        const amount = item.totalPrice && item.totalPrice.amount ? item.totalPrice.amount : 0;
        return sum + amount;
      }, 0);
    },
    barcodePrint() {
      this.$store.commit("orders/setSelectedOrders", this.selected);
      sessionStorage.setItem("barcodeprint", JSON.stringify(this.selected));
      window.open("order/barcodeprint", "_blank");
    },
    barcodePrintOld() {
      this.$store.commit("orders/setSelectedOrders", this.selected);
      sessionStorage.setItem("barcodeprint", JSON.stringify(this.selected));
      window.open("order/barcodeprint-old", "_blank");
    },
    invoicePrint() {
      this.$store.commit("orders/setSelectedOrders", this.selected);
      sessionStorage.setItem("invoiceprint", JSON.stringify(this.selected));
      window.open("order/invoiceprint", "_blank");
    },
    async poolOrderAction() {
      let selectedOrder = [];
      this.selected.forEach((element) => {
        element.items.forEach((order) => {
          selectedOrder.push({
            id: element.id,
            indicator: element.indicator,
            orderDate: element.orderDate,
            identityNo: element.identityNo,
            shipmentNo: order.orderNumber,
            recipientName: element.recipientName,
            productName: order.productName,
            quantity: order.quantity,
            amount: order.merchantUnitPrice.amount,
            totalAmount: order.totalPrice.amount,
            barcode: element.barcode,
            iban: order.customizedText01
          });
        });
      });
      await this.$store.dispatch("poolOrders/postBulkPoolOrder", { Order: selectedOrder });
      await this.initialize();
      this.$store.state.dialog = true;
      this.$store.state.message = "İşleminiz Tamamlanmıştır.";
    },
    async popupInsurance() {
      this.insuranceDialog = true;
    },
    async saveInsurance() {

      this.selected.forEach(m => {
        m.poset = `${this.posetSeri}${this.posetNo}`;
        this.posetNo--;
      })

      this.insuranceDialog = false;
      await this.$store.dispatch("orders/saveInsurance", {
        selectedItems: this.selected,
        insuranceId: this.selectedInsurance.id
      });
      this.$store.state.dialog = true;
      this.$store.state.message = "İşleminiz Tamamlanmıştır.";

      return this.selected;
    },
    async saveAction() {
      if (this.selectedAction.value == "Kargo Gönderildi")
        this.poolOrderAction();
      else {
        await this.$store.dispatch("orders/bulkUpdateStates", {
          selectedItems: this.selected,
          stateId: this.selectedAction.id,
        });
        this.$store.state.dialog = true;
        this.$store.state.message = "İşleminiz Tamamlanmıştır.";
      }

      await this.initialize();
    },
    async reSendInvoice() {
      await this.$store.dispatch("orders/reSendInvoice", {
        selectedItems: this.selected,
        stateId: this.selectedAction.id,
        isInvoiceReSend: true,
      });
      this.$store.state.dialog = true;
      this.$store.state.message = "İşleminiz Tamamlanmıştır.";


      await this.initialize();
    },

    async sendReferenceNumber(order, _orderItem) { // eslint-disable-line no-unused-vars
      const referenceNumber = this.referenceNumbers[order.id];

      if (!referenceNumber || referenceNumber.trim() === '') {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen referans numarası giriniz.";
        return;
      }

      // eslint-disable-next-line no-console
      console.log('Reference number send button clicked for order:', order.id, 'with ref:', referenceNumber);

      this.$set(this.referenceLoadingStates, order.id, true);

      try {
        await Api.post(`/api/Idefix/SendReferenceNumberToIdefix?packageNumber=${order.packageNumber}&refNumber=${referenceNumber}`);

        // eslint-disable-next-line no-console
        console.log('Reference number sent successfully for order:', order.id);

        order.isReferenceNumberSend = true;
        this.$delete(this.referenceNumbers, order.id);

        this.$store.state.dialog = true;
        this.$store.state.message = "Referans numarası başarıyla gönderildi.";

      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error sending reference number:', error);

        this.$store.state.dialog = true;
        this.$store.state.message = "Referans numarası gönderilirken hata oluştu.";

      } finally {
        this.$set(this.referenceLoadingStates, order.id, false);
      }
    },
    async loadPriceComparisonData(order) {
      this.priceComparisonData = [];
      this.priceComparisonLoading = true;

      try {
        if (!order || !order.items || !order.items.length) {
          return;
        }

        const useTransferPrice = Number(order.paymentMethod) === 0;

        const orderItems = order.items.map((item) => ({
          productId: item.productId,
          productName: item.productName,
          quantity: item.quantity,
          currentTotalPrice: item.totalPrice && item.totalPrice.amount ? Number(item.totalPrice.amount) : 0,
          currentUnitPrice:
            item.totalPrice && item.totalPrice.amount && item.quantity
              ? Number(item.totalPrice.amount) / Number(item.quantity)
              : 0,
        })).filter(item => item.productId);

        const uniqueProductIds = [...new Set(orderItems.map(item => item.productId))];

        const productPriceMap = {};
        await Promise.all(
          uniqueProductIds.map(async (productId) => {
            let resolvedPrice = 0;
            try {
              const mpProductResponse = await mpProductsApi.getMpProductByProduct(productId);
              if (mpProductResponse && mpProductResponse.data) {
                const mpProduct = mpProductResponse.data;
                if (useTransferPrice) {
                  resolvedPrice = Number(mpProduct.transferPrice || mpProduct.price || mpProduct.listPrice || 0);
                } else {
                  resolvedPrice = Number(mpProduct.price || mpProduct.transferPrice || mpProduct.listPrice || 0);
                }
              }
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error(`MpProduct ${productId} fiyatı alınamadı:`, error);
            }

            if (!resolvedPrice) {
              try {
                const productResponse = await productsApi.getProduct(productId);
                if (productResponse && productResponse.data) {
                  const product = productResponse.data;
                  resolvedPrice = Number(
                    (useTransferPrice && product.transferPrice) ||
                    product.price ||
                    product.listPrice ||
                    product.purchasePrice ||
                    0
                  );
                }
              } catch (fallbackError) {
                // eslint-disable-next-line no-console
                console.error(`Product ${productId} fiyatı alınamadı:`, fallbackError);
              }
            }

            productPriceMap[productId] = resolvedPrice;
          })
        );

        this.priceComparisonData = orderItems.map((item) => {
          const dbUnitPrice = productPriceMap[item.productId] || 0;
          const dbTotalPrice = dbUnitPrice * Number(item.quantity);
          const difference = dbTotalPrice - item.currentTotalPrice;

          return {
            productName: item.productName,
            quantity: item.quantity,
            currentUnitPrice: item.currentUnitPrice,
            currentTotalPrice: item.currentTotalPrice,
            dbUnitPrice,
            dbTotalPrice,
            difference,
          };
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Fiyat karşılaştırması hatası:", error);
        this.$store.state.dialog = true;
        this.$store.state.message = "Fiyat karşılaştırması yapılırken bir hata oluştu.";
      } finally {
        this.priceComparisonLoading = false;
      }
    },
  },
  async mounted() {
    this.$store.dispatch("orders/getCity", {}).then(() => {
    });

    // await this.$store.dispatch("insurances/getAllInsurances");
    // this.selectedInsurance = this.$store.state.insurances.insurances;
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');
    const currentUser = authenticationService.currentUserValue;

    this.tenantId = selectedTenant || (currentUser && currentUser.tenantId) || localStorage.getItem("tenantId");
    this.mpId = selectedMp || (currentUser && currentUser.mpId);

    // eslint-disable-next-line no-console
    console.log('Current tenantId:', this.tenantId);
    // eslint-disable-next-line no-console
    console.log('Current mpId:', this.mpId);

    if (this.tenantId == 1)
      this.headers = this.headers.filter((m) => m.value != "customizedText01");


    await this.initialize();
  }
};
</script>
<style>
.redd {
  color: red;
}
</style>
